export default __webpack_public_path__ + "static/cityair-maps-01dbb8a0895ff5cbcd2cc25ff7c9008c.jpg";